$(() => {
    const singleInquiryForm = document.querySelector('form#inquirycreate');
    const groupInquiryForm = document.querySelector('form#groupinquirycreate');

    const setFormSubmitDisabled = (form) => {
        const submitButton = form.querySelector('button[type=submit]');
        submitButton.setAttribute('disabled', 'disabled');
    };

    const checkFormValidityAndActivateSubmit = (e) => {
        const form = e.target.closest('form');
        const submitButton = form.querySelector('button[type=submit]');
        if (form.checkValidity() && submitButton.getAttribute('disabled')) {
            submitButton.removeAttribute('disabled');
            return;
        }

        if (!form.checkValidity() && !submitButton.getAttribute('disabled')) {
            submitButton.setAttribute('disabled', 'disabled');
        }
    };

    if (singleInquiryForm) {
        setFormSubmitDisabled(singleInquiryForm);
        singleInquiryForm.addEventListener('keyup', checkFormValidityAndActivateSubmit);
    }

    if (groupInquiryForm) {
        setFormSubmitDisabled(groupInquiryForm);
        groupInquiryForm.addEventListener('keyup', checkFormValidityAndActivateSubmit);
    }

    $('form#inquirycreate,form#groupinquirycreate').submit((event) => {
        validateForm(event);
    });

    $('#inquiryCreatedModal button').click((event) => {
        event.preventDefault();
        const modal = document.getElementById('inquiryCreatedModal');
        closeModal(modal);
    });
    const validateForm = (event) => {
        const $form = $(event.target);
        if ($form.get(0).checkValidity() === true) {
            event.preventDefault();
            submit($form);
        }
    };
    const clearinquiryCreate = ($form) => {
        $form[0].classList.remove('was-validated');
        $form[0].reset();

        setFormSubmitDisabled($form[0]);
    };

    const submit = ($form) => {
        const currentUrl = $form.get(0).getAttribute('action');
        const isGroupInquiry = $form.get(0).querySelector('input[name=GroupInquiry]') != null;
        const json = {
            InquiryName: $form.get(0).querySelector('input[name=InquiryName]').value,
            LastReply:
                $form.get(0).querySelector('input[name=LastReply]') != null
                    ? $form.get(0).querySelector('input[name=LastReply]').value
                    : null,
            GroupInquiry:
                $form.get(0).querySelector('input[name=GroupInquiry]') != null
                    ? $form.get(0).querySelector('input[name=GroupInquiry]').checked
                    : false
        };

        fetch(currentUrl, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            cache: 'no-store',
            body: JSON.stringify({ model: json })
        })
            .then((response) => response.json())
            .then((result) => {
                const modal = document.getElementById('inquiryCreatedModal');
                const modalBody = modal.querySelector('#modal-body');
                modalBody.innerHTML = '';

                if (result.success) {
                    modalBody.insertAdjacentHTML(
                        'afterbegin',
                        `<a class="btn btn-primary cta px-3 py-2 mt-2" href="${result.modalUrl}">${result.modalLinkText}
                <svg class="mr-2">
                    <use href="/dist/spritemap.svg#sprite-chevron-circle"></use>
                </svg></a>`
                    );
                    const feedBackTemplate = isGroupInquiry
                        ? document.querySelector('#feedbacktextgroupinquiry')
                        : document.querySelector('#feedbacktext');
                    modalBody.insertAdjacentHTML('afterbegin', feedBackTemplate.innerHTML);
                    //addcopylinkevent();
                    clearinquiryCreate($form);
                } else {
                    modalBody.insertAdjacentHTML(
                        'afterbegin',
                        '<div class="alert alert-danger">Något gick fel när enkäten skulle skapas. Försök igen eller kontakta kundservice.</div>'
                    );
                }
                showModal(modal);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    const closeModal = (modal) => {
        modal.classList.remove('show');
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');
        document.querySelector('.modal-backdrop').remove();
    };

    const showModal = (modal) => {
        modal.classList.add('show');
        modal.style.display = 'block';
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');
        document.body.insertAdjacentHTML(
            'afterbegin',
            '<div class="modal-backdrop fade show"></div>'
        );
    };
});
